import { toast } from "react-toastify";

export const CustomToaster = ({type, customized_message, api_message, auto_close=10000}) => {
    let tst = []
    if (type == "success") {
        tst = toast.success(
            customized_message,
            {
                position: "bottom-right",
                autoClose: auto_close,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                className: "toastify-color-success",
            }
        );
    } else if (type == "error"){
       tst = toast.error(
            customized_message + " " + api_message,
            {
                position: "bottom-right",
                autoClose: auto_close,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                className: "toastify-color-error",
            }
        );
    }
    else if (type == "warning"){
        tst = toast.warning(
             customized_message + " " + api_message,
             {
                 position: "bottom-right",
                 autoClose: auto_close,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: false,
                 progress: undefined,
                 className: "toastify-color-warning",
             }
         );
     }
     else if (type == "info"){
        tst = toast.info(
             customized_message + " " + api_message,
             {
                 position: "bottom-right",
                 autoClose: auto_close,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: false,
                 progress: undefined,
                 className: "toastify-color-info",
             }
         );
     }
    return toast
        
}